/**
 * 협력사 수수료 공통 상수 및 유틸리티
 * riderToPartner, toHeadquarters 양쪽에서 공유
 */

/** 수수료 구분 옵션 */
export const COMMISSION_TYPE_OPTIONS: { value: string; label: string }[] = [
    { value: '', label: '선택' },
    { value: 'PER_CASE_FIXED', label: '건당 정액' },
    { value: 'PER_CASE_RATE', label: '건당 정률' },
    { value: 'PER_DAY_FIXED', label: '1일 정액' },
    { value: 'PER_DAY_RATE', label: '1일 정률' },
];

/**
 * 수수료 타입에 따른 금액 단위 반환
 * @param commissionType 수수료 구분
 * @returns 단위 문자열 (원 또는 %)
 */
export const getAmountUnit = (commissionType: string): string => {
    return commissionType.includes('RATE') ? '%' : '원';
};
